import React from 'react';

interface Props {
  college: {
    loc?: [number, number];
  };
}

const CollegeMap = ({college}: Props) => {
  if (!college.loc) {
    return null;
  }

  return (
    <div className="college-profile-map">
      <iframe
        title="Google Maps"
        width="100%"
        height="242"
        style={{border: '0'}}
        src={`https://www.google.com/maps/embed/v1/view?key=AIzaSyC5W5zNGvxuJ8jVWpFSLQxTBbfW9l47WI0&zoom=12&center=${college.loc[1]},${college.loc[0]}`}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default CollegeMap;
